/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompanyUserDataItem,
  GetAccountInvitedResponse,
  GetAccountUsersResponse,
  GetCompanyInvitedResponse,
  UpdateUserRequest,
  UserControllerGetAccountInvitedUsersParams,
  UserControllerGetCompanyInvitedUsersParams,
  UserControllerGetCompanyUsersParams,
  UserControllerGetUserDataParams,
  UserDataResponse,
  UserDataWithOnboardingStatus,
  UserDetailsResponse,
  UserListResponseItem
} from './sAFcBackend.schemas.js';

import userControllerGetMyUserDataMutator from '../response-type.js';
import userControllerGetUsersListMutator from '../response-type.js';
import userControllerUpdateUserMutator from '../response-type.js';
import userControllerRemoveUserMutator from '../response-type.js';
import userControllerGetUserDataMutator from '../response-type.js';
import userControllerGetCompanyUsersMutator from '../response-type.js';
import userControllerGetAccountUsersMutator from '../response-type.js';
import userControllerGetCompanyInvitedUsersMutator from '../response-type.js';
import userControllerGetAccountInvitedUsersMutator from '../response-type.js';
import userControllerBlockUserMutator from '../response-type.js';
import userControllerUnblockUserMutator from '../response-type.js';
import userControllerGetFullUserDataMutator from '../response-type.js';
import userControllerGetUserDetailsMutator from '../response-type.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const userControllerGetMyUserData = (

 options?: SecondParameter<typeof userControllerGetMyUserDataMutator>,signal?: AbortSignal
) => {


      return userControllerGetMyUserDataMutator<UserDataWithOnboardingStatus>(
      {url: `/api/users/me`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetMyUserDataQueryKey = () => {
    return [
    `/api/users/me`
    ] as const;
    }


export const getUserControllerGetMyUserDataQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetMyUserDataMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetMyUserDataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetMyUserData>>> = ({ signal }) => userControllerGetMyUserData(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetMyUserDataQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetMyUserData>>>
export type UserControllerGetMyUserDataQueryError = unknown


export function useUserControllerGetMyUserData<TData = Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMyUserData>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMyUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetMyUserDataMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMyUserData<TData = Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMyUserData>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMyUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetMyUserDataMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMyUserData<TData = Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetMyUserDataMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetMyUserData<TData = Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyUserData>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetMyUserDataMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetMyUserDataQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const userControllerGetUsersList = (

 options?: SecondParameter<typeof userControllerGetUsersListMutator>,signal?: AbortSignal
) => {


      return userControllerGetUsersListMutator<UserListResponseItem[]>(
      {url: `/api/users/list`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetUsersListQueryKey = () => {
    return [
    `/api/users/list`
    ] as const;
    }


export const getUserControllerGetUsersListQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetUsersList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUsersList>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetUsersListMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetUsersListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetUsersList>>> = ({ signal }) => userControllerGetUsersList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUsersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetUsersList>>>
export type UserControllerGetUsersListQueryError = unknown


export function useUserControllerGetUsersList<TData = Awaited<ReturnType<typeof userControllerGetUsersList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUsersList>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetUsersListMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUsersList<TData = Awaited<ReturnType<typeof userControllerGetUsersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUsersList>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetUsersListMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUsersList<TData = Awaited<ReturnType<typeof userControllerGetUsersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUsersList>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetUsersListMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetUsersList<TData = Awaited<ReturnType<typeof userControllerGetUsersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUsersList>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetUsersListMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetUsersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Update user
 */
export const userControllerUpdateUser = (
    userId: string,
    updateUserRequest: UpdateUserRequest,
 options?: SecondParameter<typeof userControllerUpdateUserMutator>,signal?: AbortSignal
) => {


      return userControllerUpdateUserMutator<void>(
      {url: `/api/users/${userId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequest, signal
    },
      options);
    }




export const getUserControllerUpdateUserMutationKey = () => ['userControllerUpdateUser'] as const;

export const getUserControllerUpdateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateUser>>, TError,UserControllerUpdateUserMutationVariables, TContext>, request?: SecondParameter<typeof userControllerUpdateUserMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateUser>>, TError,UserControllerUpdateUserMutationVariables, TContext> => {

const mutationKey = getUserControllerUpdateUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdateUser>>, UserControllerUpdateUserMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  userControllerUpdateUser(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdateUser>>>
    export type UserControllerUpdateUserMutationBody = UpdateUserRequest
    export type UserControllerUpdateUserMutationError = unknown
    export type UserControllerUpdateUserMutationVariables = {userId: string;data: UpdateUserRequest}

    export const useUserControllerUpdateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateUser>>, TError,UserControllerUpdateUserMutationVariables, TContext>, request?: SecondParameter<typeof userControllerUpdateUserMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerUpdateUser>>,
        TError,
        UserControllerUpdateUserMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerUpdateUserMutationOptions(options), queryClient);
    }
    /**
 * Remove user from the registry
 */
export const userControllerRemoveUser = (
    userId: string,
 options?: SecondParameter<typeof userControllerRemoveUserMutator>,signal?: AbortSignal
) => {


      return userControllerRemoveUserMutator<void>(
      {url: `/api/users/${userId}`, method: 'DELETE', signal
    },
      options);
    }




export const getUserControllerRemoveUserMutationKey = () => ['userControllerRemoveUser'] as const;

export const getUserControllerRemoveUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerRemoveUser>>, TError,UserControllerRemoveUserMutationVariables, TContext>, request?: SecondParameter<typeof userControllerRemoveUserMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerRemoveUser>>, TError,UserControllerRemoveUserMutationVariables, TContext> => {

const mutationKey = getUserControllerRemoveUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerRemoveUser>>, UserControllerRemoveUserMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  userControllerRemoveUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerRemoveUserMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerRemoveUser>>>

    export type UserControllerRemoveUserMutationError = unknown
    export type UserControllerRemoveUserMutationVariables = {userId: string}

    export const useUserControllerRemoveUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerRemoveUser>>, TError,UserControllerRemoveUserMutationVariables, TContext>, request?: SecondParameter<typeof userControllerRemoveUserMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerRemoveUser>>,
        TError,
        UserControllerRemoveUserMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerRemoveUserMutationOptions(options), queryClient);
    }
    export const userControllerGetUserData = (
    userId: string,
    params: UserControllerGetUserDataParams,
 options?: SecondParameter<typeof userControllerGetUserDataMutator>,signal?: AbortSignal
) => {


      return userControllerGetUserDataMutator<UserDataResponse>(
      {url: `/api/users/${userId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserControllerGetUserDataQueryKey = (userId: string,
    params?: UserControllerGetUserDataParams,) => {
    return [
    `/api/users/${userId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserControllerGetUserDataQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetUserData>>, TError = unknown>(userId: string,
    params: UserControllerGetUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserData>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetUserDataMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetUserDataQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetUserData>>> = ({ signal }) => userControllerGetUserData(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetUserDataQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetUserData>>>
export type UserControllerGetUserDataQueryError = unknown


export function useUserControllerGetUserData<TData = Awaited<ReturnType<typeof userControllerGetUserData>>, TError = unknown>(
 userId: string,
    params: UserControllerGetUserDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserData>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetUserDataMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserData<TData = Awaited<ReturnType<typeof userControllerGetUserData>>, TError = unknown>(
 userId: string,
    params: UserControllerGetUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserData>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetUserDataMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserData<TData = Awaited<ReturnType<typeof userControllerGetUserData>>, TError = unknown>(
 userId: string,
    params: UserControllerGetUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserData>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetUserDataMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetUserData<TData = Awaited<ReturnType<typeof userControllerGetUserData>>, TError = unknown>(
 userId: string,
    params: UserControllerGetUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserData>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetUserDataMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetUserDataQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const userControllerGetCompanyUsers = (
    params: UserControllerGetCompanyUsersParams,
 options?: SecondParameter<typeof userControllerGetCompanyUsersMutator>,signal?: AbortSignal
) => {


      return userControllerGetCompanyUsersMutator<CompanyUserDataItem[]>(
      {url: `/api/users/company`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserControllerGetCompanyUsersQueryKey = (params?: UserControllerGetCompanyUsersParams,) => {
    return [
    `/api/users/company`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserControllerGetCompanyUsersQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError = unknown>(params: UserControllerGetCompanyUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetCompanyUsersMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetCompanyUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetCompanyUsers>>> = ({ signal }) => userControllerGetCompanyUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetCompanyUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetCompanyUsers>>>
export type UserControllerGetCompanyUsersQueryError = unknown


export function useUserControllerGetCompanyUsers<TData = Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError = unknown>(
 params: UserControllerGetCompanyUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetCompanyUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetCompanyUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetCompanyUsersMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetCompanyUsers<TData = Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError = unknown>(
 params: UserControllerGetCompanyUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetCompanyUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetCompanyUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetCompanyUsersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetCompanyUsers<TData = Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError = unknown>(
 params: UserControllerGetCompanyUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetCompanyUsersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetCompanyUsers<TData = Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError = unknown>(
 params: UserControllerGetCompanyUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetCompanyUsersMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetCompanyUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const userControllerGetAccountUsers = (
    accountId: string,
 options?: SecondParameter<typeof userControllerGetAccountUsersMutator>,signal?: AbortSignal
) => {


      return userControllerGetAccountUsersMutator<GetAccountUsersResponse[]>(
      {url: `/api/users/account/${accountId}`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetAccountUsersQueryKey = (accountId: string,) => {
    return [
    `/api/users/account/${accountId}`
    ] as const;
    }


export const getUserControllerGetAccountUsersQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError = unknown>(accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetAccountUsersMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetAccountUsersQueryKey(accountId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetAccountUsers>>> = ({ signal }) => userControllerGetAccountUsers(accountId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: accountId !== null && accountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetAccountUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetAccountUsers>>>
export type UserControllerGetAccountUsersQueryError = unknown


export function useUserControllerGetAccountUsers<TData = Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError = unknown>(
 accountId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetAccountUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetAccountUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetAccountUsersMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetAccountUsers<TData = Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError = unknown>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetAccountUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetAccountUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetAccountUsersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetAccountUsers<TData = Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError = unknown>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetAccountUsersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetAccountUsers<TData = Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError = unknown>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetAccountUsersMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetAccountUsersQueryOptions(accountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const userControllerGetCompanyInvitedUsers = (
    params: UserControllerGetCompanyInvitedUsersParams,
 options?: SecondParameter<typeof userControllerGetCompanyInvitedUsersMutator>,signal?: AbortSignal
) => {


      return userControllerGetCompanyInvitedUsersMutator<GetCompanyInvitedResponse[]>(
      {url: `/api/users/invited/company`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserControllerGetCompanyInvitedUsersQueryKey = (params?: UserControllerGetCompanyInvitedUsersParams,) => {
    return [
    `/api/users/invited/company`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserControllerGetCompanyInvitedUsersQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError = unknown>(params: UserControllerGetCompanyInvitedUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetCompanyInvitedUsersMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetCompanyInvitedUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>> = ({ signal }) => userControllerGetCompanyInvitedUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetCompanyInvitedUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>>
export type UserControllerGetCompanyInvitedUsersQueryError = unknown


export function useUserControllerGetCompanyInvitedUsers<TData = Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError = unknown>(
 params: UserControllerGetCompanyInvitedUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetCompanyInvitedUsersMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetCompanyInvitedUsers<TData = Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError = unknown>(
 params: UserControllerGetCompanyInvitedUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetCompanyInvitedUsersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetCompanyInvitedUsers<TData = Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError = unknown>(
 params: UserControllerGetCompanyInvitedUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetCompanyInvitedUsersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetCompanyInvitedUsers<TData = Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError = unknown>(
 params: UserControllerGetCompanyInvitedUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetCompanyInvitedUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetCompanyInvitedUsersMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetCompanyInvitedUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const userControllerGetAccountInvitedUsers = (
    params: UserControllerGetAccountInvitedUsersParams,
 options?: SecondParameter<typeof userControllerGetAccountInvitedUsersMutator>,signal?: AbortSignal
) => {


      return userControllerGetAccountInvitedUsersMutator<GetAccountInvitedResponse[]>(
      {url: `/api/users/invited/account`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserControllerGetAccountInvitedUsersQueryKey = (params?: UserControllerGetAccountInvitedUsersParams,) => {
    return [
    `/api/users/invited/account`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserControllerGetAccountInvitedUsersQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError = unknown>(params: UserControllerGetAccountInvitedUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetAccountInvitedUsersMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetAccountInvitedUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>> = ({ signal }) => userControllerGetAccountInvitedUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetAccountInvitedUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>>
export type UserControllerGetAccountInvitedUsersQueryError = unknown


export function useUserControllerGetAccountInvitedUsers<TData = Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError = unknown>(
 params: UserControllerGetAccountInvitedUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetAccountInvitedUsersMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetAccountInvitedUsers<TData = Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError = unknown>(
 params: UserControllerGetAccountInvitedUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetAccountInvitedUsersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetAccountInvitedUsers<TData = Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError = unknown>(
 params: UserControllerGetAccountInvitedUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetAccountInvitedUsersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetAccountInvitedUsers<TData = Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError = unknown>(
 params: UserControllerGetAccountInvitedUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAccountInvitedUsers>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetAccountInvitedUsersMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetAccountInvitedUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Block user
 */
export const userControllerBlockUser = (
    userId: string,
 options?: SecondParameter<typeof userControllerBlockUserMutator>,signal?: AbortSignal
) => {


      return userControllerBlockUserMutator<void>(
      {url: `/api/users/${userId}/block`, method: 'PATCH', signal
    },
      options);
    }




export const getUserControllerBlockUserMutationKey = () => ['userControllerBlockUser'] as const;

export const getUserControllerBlockUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerBlockUser>>, TError,UserControllerBlockUserMutationVariables, TContext>, request?: SecondParameter<typeof userControllerBlockUserMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerBlockUser>>, TError,UserControllerBlockUserMutationVariables, TContext> => {

const mutationKey = getUserControllerBlockUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerBlockUser>>, UserControllerBlockUserMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  userControllerBlockUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerBlockUserMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerBlockUser>>>

    export type UserControllerBlockUserMutationError = unknown
    export type UserControllerBlockUserMutationVariables = {userId: string}

    export const useUserControllerBlockUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerBlockUser>>, TError,UserControllerBlockUserMutationVariables, TContext>, request?: SecondParameter<typeof userControllerBlockUserMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerBlockUser>>,
        TError,
        UserControllerBlockUserMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerBlockUserMutationOptions(options), queryClient);
    }
    /**
 * Unblock user
 */
export const userControllerUnblockUser = (
    userId: string,
 options?: SecondParameter<typeof userControllerUnblockUserMutator>,signal?: AbortSignal
) => {


      return userControllerUnblockUserMutator<void>(
      {url: `/api/users/${userId}/unblock`, method: 'PATCH', signal
    },
      options);
    }




export const getUserControllerUnblockUserMutationKey = () => ['userControllerUnblockUser'] as const;

export const getUserControllerUnblockUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUnblockUser>>, TError,UserControllerUnblockUserMutationVariables, TContext>, request?: SecondParameter<typeof userControllerUnblockUserMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUnblockUser>>, TError,UserControllerUnblockUserMutationVariables, TContext> => {

const mutationKey = getUserControllerUnblockUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUnblockUser>>, UserControllerUnblockUserMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  userControllerUnblockUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUnblockUserMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUnblockUser>>>

    export type UserControllerUnblockUserMutationError = unknown
    export type UserControllerUnblockUserMutationVariables = {userId: string}

    export const useUserControllerUnblockUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUnblockUser>>, TError,UserControllerUnblockUserMutationVariables, TContext>, request?: SecondParameter<typeof userControllerUnblockUserMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerUnblockUser>>,
        TError,
        UserControllerUnblockUserMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerUnblockUserMutationOptions(options), queryClient);
    }
    export const userControllerGetFullUserData = (
    userId: string,
 options?: SecondParameter<typeof userControllerGetFullUserDataMutator>,signal?: AbortSignal
) => {


      return userControllerGetFullUserDataMutator<UserDataResponse>(
      {url: `/api/users/${userId}/full`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetFullUserDataQueryKey = (userId: string,) => {
    return [
    `/api/users/${userId}/full`
    ] as const;
    }


export const getUserControllerGetFullUserDataQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError = unknown>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetFullUserDataMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetFullUserDataQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetFullUserData>>> = ({ signal }) => userControllerGetFullUserData(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetFullUserDataQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetFullUserData>>>
export type UserControllerGetFullUserDataQueryError = unknown


export function useUserControllerGetFullUserData<TData = Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError = unknown>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetFullUserData>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetFullUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetFullUserDataMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetFullUserData<TData = Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetFullUserData>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetFullUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetFullUserDataMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetFullUserData<TData = Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetFullUserDataMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetFullUserData<TData = Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetFullUserData>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetFullUserDataMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetFullUserDataQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const userControllerGetUserDetails = (
    userId: string,
 options?: SecondParameter<typeof userControllerGetUserDetailsMutator>,signal?: AbortSignal
) => {


      return userControllerGetUserDetailsMutator<UserDetailsResponse>(
      {url: `/api/users/${userId}/details`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetUserDetailsQueryKey = (userId: string,) => {
    return [
    `/api/users/${userId}/details`
    ] as const;
    }


export const getUserControllerGetUserDetailsQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError = unknown>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetUserDetailsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetUserDetailsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetUserDetails>>> = ({ signal }) => userControllerGetUserDetails(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetUserDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetUserDetails>>>
export type UserControllerGetUserDetailsQueryError = unknown


export function useUserControllerGetUserDetails<TData = Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError = unknown>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserDetails>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetUserDetailsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserDetails<TData = Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserDetails>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof userControllerGetUserDetailsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserDetails<TData = Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetUserDetailsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetUserDetails<TData = Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserDetails>>, TError, TData>>, request?: SecondParameter<typeof userControllerGetUserDetailsMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetUserDetailsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






